export const msalConfig = {
    auth: {
      clientId: "c180fcdb-f97e-482c-a42c-9af3f4d8f7b8",
      authority: "https://login.microsoftonline.com/9c984c59-1346-40ee-833f-330437a233ce", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      redirectUri: window.location.href
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequest = {
   scopes: ["User.Read"]
  };
  
  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  export const graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
  };